import React, { useContext } from 'react';
import { MarketingContext } from '@core-ui/marketing-provider';
import { propTypes } from './types';

const getDivisionId = selectedNodes => {
  return selectedNodes.find(({ type }) => type === 'division' || type === 'sub-division') || {};
};

const getCategoryId = selectedNodes => {
  return selectedNodes.find(({ type }) => type === 'category' || type === 'sale') || {};
};

const RailMarketingCurtain = ({ position = 'top', selectedNodes, abbrBrand }) => {
  const { contentData, PageMarketing = () => (<div></div>) } = useContext(MarketingContext);
  
  const { id: did } = getDivisionId(selectedNodes);
  const { id: cid } = getCategoryId(selectedNodes);

  const marketingData = contentData?.division?.[did]?.['left-nav-banners'];
  const showCurtain = !marketingData?.excludedCids?.includes(cid);

  return (showCurtain ? (
      <PageMarketing
              {...marketingData}
              abbrBrand={abbrBrand}
              cid={cid}
              divisionId={did}
              componentData={marketingData?.data?.components?.[position]}
              mktingType="left-nav-banners"
              position={position}
            />
    ) : null
  );
};

export default RailMarketingCurtain;

RailMarketingCurtain.propTypes = propTypes;
